const it = {
    '/': {
        title: '{brand} | Scommesse Sportive, Casino Live & Prelievi Istantanei',
        description: 'Slot, casino live & scommesse sportive su {brand}. Casino crypto con prelievi istantanei, giochi equi & supporto 24/7.'
    },
    '/casino': {
        title: 'Casino Online | Slot, Blackjack & Dealer Live | {brand}',
        description: 'Slot, blackjack, roulette & dealer live su {brand}. Centinaia di giochi, depositi crypto veloci & prelievi istantanei disponibili 24/7.'
    },
    '/sports': {
        title: 'Scommesse Sportive Online | Scommesse Crypto & Quote | {brand}',
        description: 'Scommetti sullo sport su {brand}. Quote competitive su calcio, basket & altro. Scommesse live, puntate crypto sicure & pagamenti rapidi.'
    },
    '/livecasino': {
        title: 'Casino Live | Blackjack, Roulette & Dealer dal Vivo | {brand}',
        description: 'Blackjack, roulette & giochi di casino live su {brand}. Dealer reali, streaming HD & ampia selezione di tavoli live disponibili 24/7.'
    },
    '/slots': {
        title: 'Slot Online | Ampia Varietà di Slot da Casino | {brand}',
        description: "Un'enorme collezione di slot su {brand}. Macchine classiche, video slot & progressive, tutte giocabili con crypto."
    },
    '/vip': {
        title: 'Programma VIP | Premi Esclusivi & Vantaggi | {brand}',
        description: 'Il programma VIP di {brand}: premi esclusivi, bonus personalizzati e supporto prioritario. Vantaggi per i giocatori fedeli.'
    },
    '/welcome-offer': {
        title: 'Offerta di Benvenuto | Casino Crypto | {brand}',
        description: "Scopri l'offerta di benvenuto di {brand}. Inizia con le crypto e goditi vantaggi esclusivi per i nuovi giocatori."
    },
    '/referral': {
        title: 'Programma di Referral | Guadagna Premi | {brand}',
        description: 'Invita amici su {brand} e guadagna premi quando si iscrivono e soddisfano i requisiti.'
    },
    '/promotion-page': {
        title: 'Promozioni | Bonus & Offerte Speciali | {brand}',
        description: 'Tutte le promozioni attive su {brand}. Bonus, giri gratuiti e offerte speciali per i giocatori crypto.'
    },
    '/hotslots': {
        title: 'Slot Popolari | Slot Casino Più Giocate | {brand}',
        description: 'Gioca alle slot più popolari su {brand}. Le slot più calde disponibili con crypto.'
    },
    '/newgames': {
        title: 'Nuovi Giochi | Ultimi Giochi da Casino | {brand}',
        description: 'Scopri i più recenti giochi da casino su {brand}. Nuove slot, giochi live e giochi da tavolo aggiunti regolarmente.'
    },
    '/populargames': {
        title: 'Giochi Popolari | I Giochi da Casino Più Giocati | {brand}',
        description: 'I giochi da casino più popolari su {brand}. Dalle slot ai giochi live, tutto disponibile con crypto.'
    },
    '/gameshows': {
        title: 'Game Show | Casino con Show dal Vivo | {brand}',
        description: 'Goditi i migliori game show dal vivo su {brand}. Conduttori veri, giochi unici e grandi vincite in tempo reale.'
    },
    '/table_games': {
        title: 'Giochi da Tavolo | Blackjack, Roulette & Baccarat | {brand}',
        description: 'Gioca a blackjack, roulette, baccarat e altri giochi da tavolo su {brand}. Tutto disponibile con crypto.'
    },
    '/hotlive': {
        title: 'Casino Live Popolare | Giochi Live Più Giocati | {brand}',
        description: 'I giochi di casino live più popolari su {brand}. Gioca con veri dealer in tempo reale.'
    },
    '/featurebuyin': {
        title: 'Slot con Acquisto Bonus | Feature Buy-in | {brand}',
        description: 'Gioca a slot con la possibilità di acquistare il bonus su {brand}. Accedi direttamente al round bonus senza aspettare.'
    }
};
export default it;
